import { defineComponent as _defineComponent } from 'vue'
import { inject, ref, ComputedRef } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Day',
  props: {
    name: null,
    current: { type: Boolean },
    isHeader: { type: Boolean }
  },
  emits: ["drag-end"],
  setup(__props: any, { emit }: { emit: ({ (name: 'drag-end'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  name: string
  current: boolean
  isHeader?: boolean
}



const isDragging = inject<{ isDragging: ComputedRef<boolean> }>('isDragging')
const isDragEnter = ref(false)

function onDrop() {
  emit('drag-end')
  isDragEnter.value = false
}

function toggleDragEnter() {
  isDragEnter.value = !isDragEnter.value
}

return { __sfc: true,props, emit, isDragging, isDragEnter, onDrop, toggleDragEnter }
}

})